import { AppConfig } from '@hcs/types';

declare global {
  interface Window {
    BUNDLE_APP_CONFIGS?: AppConfig[];
  }
}
/** Returns all AppConfigs that are defined for the current bundle */
export const useBundleAppConfigs = () => window.BUNDLE_APP_CONFIGS;
